import Label from "./Label";

export default function Checkbox({ label, name, value, checked, onChange, labelStyle = {}, className, textColor }) {
    return (
        <Label text={label} horizontalStyle customStyle={labelStyle} textColor={textColor}>
            <input 
                type="checkbox" 
                name={name} 
                className={`checkbox ${className || ""}`} 
                checked={checked} 
                onChange={onChange}
                value={value}
            />
        </Label>
    )
}